import { Button } from '@givebutter/primitives/button';
import { faBarsFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    AdvancedTemplateCategory,
    advancedTemplateCategories,
} from 'assets/js/pages/engage/components/constants';
import { useAdvancedTemplateCategorySelection } from 'assets/js/pages/engage/useAdvancedTemplateCategorySelection';
import * as DropdownMenu from 'components/dropdown-menu';

const AdvancedTemplateCategories = () => {
    const { selectedCategories, setSelectedCategories } = useAdvancedTemplateCategorySelection();

    const onCheckedChange = (checked: boolean, category: AdvancedTemplateCategory) => {
        setSelectedCategories(
            checked
                ? [...selectedCategories, category.id]
                : selectedCategories.filter(c => c !== category.id),
        );
    };
    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                <Button variant="transparent" className="!text-gray-500">
                    <FontAwesomeIcon icon={faBarsFilter} size="sm" />
                    Categories
                </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content className="max-h-60 overflow-auto" align="start">
                {advancedTemplateCategories.map(category => {
                    const checked = selectedCategories.includes(category.id);
                    return (
                        <DropdownMenu.CheckboxItem
                            key={category.id}
                            checked={checked}
                            onCheckedChange={checked => onCheckedChange(!!checked, category)}
                            className="m-0 p-1 px-2"
                        >
                            {category.name}
                        </DropdownMenu.CheckboxItem>
                    );
                })}
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
};

export { AdvancedTemplateCategories };
